import { render } from "./ShiftKPIDialog.vue?vue&type=template&id=ea594b80&ts=true"
import script from "./ShiftKPIDialog.ts?vue&type=script&lang=ts"
export * from "./ShiftKPIDialog.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__